import React, { useState, useEffect } from "react";

import ConversationHeader from "./ConversationHeader";
import ParticipantInfo from "./ParticipantInfo";
import ConversationSearch from "./ConversationSearch";
import ConversationBody from "./ConversationBody";
import ConversationFooter from "./ConversationFooter";
import Avatar from "../Common/Avatar";
import i18n from "./../../i18n";

function ConversationComponent({
  Conversation,
  isLoading,
  scrolltop,
  getConversationContent,
  leaveConversation,
  oponentId,
  isgroup,
  avatar,
  loadMore,
  openConversationModal,
  oponentName,
  user,
  deleteGroupHandler,
  selectedContactNameChangeHandler,
}) {
  //Conversation participant dropdown menu
  const [participantMenu, toggleParticipantMenu] = useState(false);

  const toggleParticipantDropdown = () =>
    toggleParticipantMenu(!participantMenu);

  //Participant chat info
  const [participantChatInfo, toggleParticipantChatInfo] = useState(false);

  const deleteGroup = (id) => {
    toggleParticipantChatInfo(false);
    deleteGroupHandler(id);
  };

  const hideParticipantChatInfo = () => {
    toggleParticipantChatInfo(false);
  };

  // const [participantChatDetails, setParticipantChatDetails] = useState([]);

  // useEffect(() => {
  //   fetchParticipantDetail().then((res) => {
  //     setParticipantChatDetails(res);
  //   }, []);
  // });

  return (
    <main className={oponentId ? "main main-visible" : "main"}>
      <div className="chats">
        {oponentId ? (
          (Conversation && Conversation.length) || !isLoading ? (
            <div className="chat-body">
              <ConversationHeader
                toggleParticipantChatInfo={toggleParticipantChatInfo}
                leaveConversation={leaveConversation}
                oponentName={oponentName}
                oponentId={oponentId}
                isgroup={isgroup}
                avatar={avatar}
              />
              <ConversationSearch />
              <ConversationBody
                messages={Conversation}
                isLoading={isLoading}
                scrolltop={scrolltop}
                getConversationContent={getConversationContent}
                oponentId={oponentId}
                isgroup={isgroup}
                loadMore={loadMore}
                user={user}
                selectedContactNameChangeHandler={
                  selectedContactNameChangeHandler
                }
              />
              <ConversationFooter
                isGroup={isgroup}
                messageToId={oponentId}
                getConversationContent={getConversationContent}
              />
            </div>
          ) : (
            isLoading && (
              <div id="loading-bg">
                <div className="loading">
                  <div className="effect-1 effects"></div>
                  <div className="effect-2 effects"></div>
                  <div className="effect-3 effects"></div>
                </div>
              </div>
            )
          )
        ) : (
          <div className="d-flex flex-column justify-content-center text-center h-100 w-100">
            <div className="container">
              <div className="start-new-conversation">
                <Avatar id={user.id} isGroup={false} imgPath={user.avatar} />
                {/* <div className="avatar avatar-lg mb-2">
                  <img
                    className="avatar-img"
                    src="/media/avatar/4.png"
                    alt=""
                  />
                </div> */}
                <h5>
                  {i18n.t("wellcome")}
                  {`, ${user.name}`}
                </h5>
                <p className="text-muted">{i18n.t("start.chating")}</p>
                <button
                  onClick={() => openConversationModal()}
                  className="btn btn-outline-primary no-box-shadow"
                  type="button"
                  data-toggle="modal"
                  data-target="#startConversation"
                >
                  {i18n.t("start")}
                </button>
              </div>
            </div>
          </div>
        )}

        {participantChatInfo && (
          <ParticipantInfo
            hideParticipantChatInfo={hideParticipantChatInfo}
            groupId={isgroup ? oponentId : null}
            personId={isgroup ? null : oponentId}
            user={user}
            deleteGroupHandler={deleteGroup}
            selectedContactNameChangeHandler={selectedContactNameChangeHandler}
          />
        )}
      </div>
    </main>
  );
}

export default ConversationComponent;
